/* eslint-disable import/prefer-default-export */
import Home from "./Home";

export { Home };
